export default () => ({
  show: false,
  init() {
    this.show = true;
  },
  close() {
    this.show = false;
  },
  findLocation() {
    const positionSuccess = (pos) => {
      this.$dispatch("geoLocationUpdated", { message: pos });
      this.close();
    };
    // Todo: maybe display error message to user
    const positionError = (err) => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
      this.close();
    };
    const options = {
      enableHighAccuracy: false,
      timeout: 15000,
      maximumAge: 60000,
    };
    navigator.geolocation.getCurrentPosition(
      positionSuccess,
      positionError,
      options
    );
  },
  toggle() {
    this.show = !this.show;
    Grebify.noScroll(!this.show);
  },
});
